import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { GenericServiceService } from '../../services/generic-service.service';

@Component({
  selector: 'app-tag-list',
  templateUrl: './tag-list.component.html',
  styleUrls: ['./tag-list.component.scss']
})
export class TagListComponent implements OnInit {
  model: any = {};
  tagList: any = [];
  p=1;
  constructor(
    private router: Router,
    private genericService: GenericServiceService,

  ) { }

  ngOnInit() {
    this.getAllTags();

  }
  AddTagNavigation() {
    this.router.navigateByUrl('/tags/addTag');
  }

  getAllTags() {
    this.genericService.getAllTags().subscribe(Response => {
      this.tagList = Response;
    });
  }
}
